import { defineComponent } from "vue";

import MciLayout from "../../vue-elements/MciLayout/Mcilayout.vue";
import ReferralHeader from "../ReferralHeader/ReferralHeader.vue";

export default defineComponent({
    components: {
        MciLayout,
        ReferralHeader
    },

    props: {
        tabs: {
            type: Array
        },
        activeTab: {
            type: Number
        },
        handleTabChange: {
            type: Function
        },
        showWarnings: {
            type: Function
        },
        showErrors: {
            type: Function
        },
        numberOfWarnings: {
            type: Function
        },
        numberOfErrors: {
            type: Function
        },
        showSuccess: {
            type: Function
        },
        header: {
            type: String
        }
    }
});
